var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 7,
  height: 7,
  viewBox: "0 0 7 7"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "downtriangle-a",
  points: "0 0 6 0 6 4 0 4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "downtriangle-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#downtriangle-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.0039,-2e-05 L4.9949,-2e-05 C5.8339,-2e-05 6.3029,0.96898 5.7809,1.62598 L3.6509,3.75998 C3.2759,4.07998 2.7239,4.07998 2.3489,3.75998 L0.2189,1.62498 C-0.3021,0.96798 0.1659,-2e-05 1.0039,-2e-05",
  mask: "url(#downtriangle-b)"
}))));
export default SvgDownTriangle;